/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessCount
 */
export interface BusinessCount {
    /**
     * 
     * @type {number}
     * @memberof BusinessCount
     */
    count: number;
}

/**
 * Check if a given object implements the BusinessCount interface.
 */
export function instanceOfBusinessCount(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function BusinessCountFromJSON(json: any): BusinessCount {
    return BusinessCountFromJSONTyped(json, false);
}

export function BusinessCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
    };
}

export function BusinessCountToJSON(value?: BusinessCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
    };
}

